import api from '../../../services/api';

export interface CommunicationLogDto {
  id: string;
  userId: string | null;
  orderId: string | null;
  eventType: string;
  channel: 'email' | 'telegram';
  recipient: string;
  subject: string | null;
  content: string | null;
  status: 'sent' | 'failed' | 'pending';
  errorMessage: string | null;
  metadata: Record<string, unknown> | null;
  createdAt: string;
  userName?: string | null;
  userEmail?: string | null;
  orderNumber?: string | null;
  /** Canonical operator-facing OMS number (manual number when active, raw otherwise). */
  displayOrderNumber?: string | null;
}

export interface CommunicationLogFilters {
  recipient?: string;
  orderNumber?: string;
  eventType?: string;
  channel?: string;
  status?: string;
  dateFrom?: string;
  dateTo?: string;
  limit?: number;
  offset?: number;
}

export async function fetchAllCommunications(
  filters: CommunicationLogFilters = {}
): Promise<CommunicationLogDto[]> {
  const params: Record<string, string | number> = {};
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      params[key] = value;
    }
  });
  const response = await api.get('/notifications/log/all', { params });
  return response.data;
}

export async function fetchOrderCommunications(
  orderId: string,
  limit = 100
): Promise<CommunicationLogDto[]> {
  const response = await api.get(`/notifications/log/order/${orderId}`, {
    params: { limit },
  });
  return response.data;
}
